import React from "react"
import styled from "@emotion/styled"
import { Container, Flex } from "theme-ui"
import ResourceList from "components/lists/resources-list"

const Wrapper = styled.div`
    position: relative;
    text-align: center;
    color: ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.colors.soft_green};
    padding: 2rem 0;

    & .position {
        justify-content: center;
    }

    & .resources-wrapper {
        justify-content: space-between;
        margin: auto;
        flex-direction: row;
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[8]}) {
        }

        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[7]}) {
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[3]}) {
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[2]}) {
        }
    }

    & h2 {
        margin-bottom: 0;
        color: ${(props) => props.theme.colors.primary};
    }

    & .resources-card {
        & p, & h3 {
            color: ${(props) => props.theme.colors.primary};
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[8]}) {
        padding: 0 2rem;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        & h2 {
            margin-top: 0;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        padding: 0 1rem;
        & .resources-wrapper {
            flex-direction: column;
            padding: 0;
        }
    }
    
`

function Resources({ data, description }) {
    return (
        <>
            <Wrapper>
                <Container>
                    <Flex className="position">
                        <h2>Resources</h2>
                    </Flex>
                    <Flex
                        className="position"
                        sx={{
                            margin: "auto",
                        }}
                    >
                        <div
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    </Flex>
                    <Flex className="resources-wrapper">
                        <ResourceList data={{ posts: data }} />
                    </Flex>
                </Container>
            </Wrapper>
        </>
    )
}

export default Resources
